export default __webpack_public_path__ + "static/media/inactive-intake.1c8a3006.svg";